import moment from 'moment'
import {Map} from 'immutable'
import {withoutTZOffset} from 'lib/dateUtils'
import _ from 'lodash'

export const firstVisibleDay = (date) => {
  // moment() is important as it will clone date instead of mutating date
  return moment(date).startOf('month').startOf('week')
}

export const lastVisibleDay = (date) => {
  // moment() is important as it will clone date instead of mutating date
  return moment(date).endOf('month').endOf('week')
}

export const isTrip = (obj) => {
  return _.hasIn(obj, 'departedAt')
}

export const isEvent = (obj) => {
  return _.hasIn(obj, 'startsOn')
}

const TODAY_STRING = moment().format('YYYY-MM-DD')
export const isPast = (e, reference) => {
  const endDate = e.ends_on || e.endsOn || e.ends_at || e.endsAt || e.starts_on || e.startsOn
  if (!endDate) { return false } // unscheduled events aren't in the past
  return endDate < TODAY_STRING // event is only past if it ends before today
}

export const getType = (obj) => {
  if (isTrip(obj)) {
    return 'trip'
  }
  if (isEvent(obj)) {
    return 'event'
  }
  console.warn('Unable to determine a type for given event object', obj)
  return 'unknown'
}

// Helper method for indexEventsByDate
// exported for testing
export const getRangeArr = (start, end) => {
  const mstart = moment(start)

  let arr = [mstart]
  if (!end || start === end) {
    return arr
  }

  while (arr[arr.length - 1].isBefore(end, 'day')) {
    const last = arr[arr.length - 1]
    arr.push(last.clone().add(1, 'day'))
  }
  return arr
}
const getAllEventDays = (e, startAccessor, endAccessor) => {
  const start = withoutTZOffset(startAccessor(e))
  const end = withoutTZOffset(endAccessor(e))
  return getRangeArr(start, end)
}

export const indexEventsByDate = (events, startAccessor, endAccessor) => {
  return Map().withMutations(eventIndex => {
    events.forEach(event => {
      const days = getAllEventDays(event, startAccessor, endAccessor)
      days.forEach(d => {
        const dayKey = d.format('YYYY-MM-DD')
        const objectIdentifier = `${getType(event)}-${event.id}`
        eventIndex.setIn([dayKey, objectIdentifier], event)
      })
    })
  })
}

export const shortTimeStr = (m) => {
  if (m.hour() > 0 && m.minute() > 0) {
    return m.format('H:mm A')
  }

  if (m.hour() > 0) {
    return m.format('H A')
  }

  return ''
}
